// extracted by mini-css-extract-plugin
export default {"duration":"TimestampOverlay-module__duration_teYD0","lowerRight":"TimestampOverlay-module__lowerRight_XPdVb","lowerLeft":"TimestampOverlay-module__lowerLeft_M0NYx"};